<template>
	<div class="tablenav-pages">
		<span class="displaying-num">{{count}} {{ count === 1 ? 'item' : 'items' }}</span>
		<!-- The "First" page button -->
		<span class="tablenav-pages-navspan button" :class="{ disabled: page === 1 }">
			«
		</span>
		<span class="tablenav-pages-navspan button" :class="{ disabled: page === 1 }">
			‹
		</span>
		<span id="table-paging" class="paging-input">
			<span class="tablenav-paging-text">
				{{page}} of <span class="total-pages">{{totalPages}}</span>
			</span>
		</span>
		<span class="tablenav-pages-navspan button" :class="{ disabled: page === totalPages }">
			›
		</span>
		<span class="tablenav-pages-navspan button" :class="{ disabled: page === totalPages }">
			»
		</span>
	</div>
</template>

<script>
export default {
	name     : 'wordpressPagination',
	props    : [ 'page', 'perPage', 'count', 'setPageCallback' ],
	computed : {
		/**
		* Calculate the number of total pages we need
		* @returns {int} The total Page number
		*/
		totalPages () {
			return Math.ceil(this.count / this.perPage)
		},
	},
}
</script>
